(function () {
  if (window.PlaudStickyHeaderCoordinator) return;

  const owners = new Set();
  const subscribers = new Set();
  const saved = new Map();
  let targets = [];
  let observer;
  let resizeObserver;
  let frame = 0;

  function restore(element) {
    const original = saved.get(element);
    if (!original) return;
    original.styles.forEach(([property, value, priority]) => {
      if (value) element.style.setProperty(property, value, priority);
      else element.style.removeProperty(property);
    });
    element.inert = original.inert;
    saved.delete(element);
  }

  function apply() {
    const suppress = owners.size > 0;
    targets.forEach((element) => {
      if (!suppress) return restore(element);
      if (saved.has(element)) return;
      saved.set(element, {
        inert: element.inert,
        styles: ['visibility', 'opacity', 'pointer-events'].map((property) => [
          property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)
        ])
      });
      // Preserve document height and the theme's own sticky classes/inline styles.
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
      element.inert = true;
    });
  }

  function schedule() {
    if (frame || !subscribers.size) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      apply();
      subscribers.forEach((callback) => callback());
    });
  }

  function refreshTargets() {
    saved.forEach((_, element) => restore(element));
    observer?.disconnect();
    resizeObserver?.disconnect();
    const header = document.querySelector('.section-header') || document.querySelector('.header__inner');
    targets = Array.from(new Set([
      header,
      ...document.querySelectorAll('.section-announcement-bar, .section-top-bar, [data-newbar-root], [id^="shopify-section-announcement_newbar"]')
    ].filter(Boolean).map((element) => element.closest('.shopify-section') || element)));
    targets = targets.filter((element) => !targets.some((other) => other !== element && other.contains(element)));
    observer = new MutationObserver(schedule);
    resizeObserver = new ResizeObserver(schedule);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    targets.forEach((element) => observer.observe(element, {
      subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-expanded']
    }));
    targets.forEach((element) => resizeObserver.observe(element));
    schedule();
  }

  function getOffset() {
    const rects = targets.flatMap((element) => {
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return [];
      if (style.position !== 'sticky' && style.position !== 'fixed') return [];
      return [element.getBoundingClientRect()];
    }).sort((a, b) => a.top - b.top);
    return rects.reduce((bottom, rect) =>
      rect.top <= bottom && rect.bottom > 0 ? Math.max(bottom, rect.bottom) : bottom, 0);
  }

  // Consumers subscribe for changes, then request/release with their own identity.
  // One instance must never restore a header another still owns.
  window.PlaudStickyHeaderCoordinator = {
    getOffset,
    request(owner, active) {
      if (owners.has(owner) === active) return;
      if (active) owners.add(owner);
      else owners.delete(owner);
      apply();
      schedule();
    },
    release(owner) {
      this.request(owner, false);
    },
    subscribe(callback) {
      subscribers.add(callback);
      if (subscribers.size === 1) {
        refreshTargets();
        document.addEventListener('transitionend', schedule);
        document.addEventListener('shopify:section:load', refreshTargets);
        document.addEventListener('shopify:section:unload', refreshTargets);
      }
      return () => {
        subscribers.delete(callback);
        if (subscribers.size) return;
        cancelAnimationFrame(frame);
        frame = 0;
        observer?.disconnect();
        resizeObserver?.disconnect();
        document.removeEventListener('transitionend', schedule);
        document.removeEventListener('shopify:section:load', refreshTargets);
        document.removeEventListener('shopify:section:unload', refreshTargets);
        owners.clear();
        saved.forEach((_, element) => restore(element));
        targets = [];
      };
    }
  };
})();
